import React from 'react';
import { Page } from '../Page';
import { HeartPulse, Footprints, Smile, Zap } from 'lucide-react';
export function Page10() {
  return <Page pageNumber={26} variant="light" data-id="element-505">
      <div className="flex flex-col h-full" data-id="element-506">
        {/* Hero Image Header */}
        <div className="relative h-[380px] -mx-12 -mt-10 mb-10 overflow-hidden" data-id="element-507">
          <img src="https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?w=1000&q=80" alt="Cardio running" className="w-full h-full object-cover" data-id="element-508" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-[#F5F5F0]/60 to-transparent" data-id="element-509" />

          <div className="absolute bottom-0 left-12 right-12 pb-6" data-id="element-510">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-2" data-id="element-511">
              The Essentials
            </p>
            <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight" data-id="element-512">
              Cardiovascular <span className="text-tealslate" data-id="element-513">Health</span>
            </h1>
          </div>
        </div>

        <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-8 max-w-2xl" data-id="element-514">
          While weight lifting protects your metabolism and muscle mass, cardio
          protects your heart and improves your stamina. You need both, but they
          serve different purposes.
        </p>

        <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-6 text-center mb-10" data-id="element-515">
          <h2 className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-2" data-id="element-516">
            The Goal
          </h2>
          <div className="text-3xl font-serif text-[#1F1F1F] mb-2" data-id="element-517">
            150 Minutes Per Week
          </div>
          <p className="text-xs text-[#7A7A70] leading-[1.8] max-w-md mx-auto" data-id="element-518">
            Aim for a pace where singing is hard and talking takes effort. Brisk
            walking, jogging, or dancing all count.
          </p>
        </div>

        <div className="grid grid-cols-3 gap-6 mb-10" data-id="element-519">
          <div className="flex flex-col items-center text-center" data-id="element-520">
            <HeartPulse className="w-8 h-8 text-tealslate mb-3" data-id="element-521" />
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-1" data-id="element-522">
              Heart Health
            </h3>
            <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-523">
              Strengthens your cardiovascular system.
            </p>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-524">
            <Smile className="w-8 h-8 text-tealslate mb-3" data-id="element-525" />
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-1" data-id="element-526">
              Mood Boost
            </h3>
            <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-527">
              Releases endorphins and reduces stress.
            </p>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-528">
            <Zap className="w-8 h-8 text-tealslate mb-3" data-id="element-529" />
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-1" data-id="element-530">
              More Energy
            </h3>
            <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-531">
              Builds stamina for everyday activities.
            </p>
          </div>
        </div>

        <div className="flex-1 flex flex-col justify-end space-y-4" data-id="element-532">
          <div className="flex items-start gap-4 border-t border-[#D8D8D0] pt-6" data-id="element-533">
            <Footprints className="w-6 h-6 text-tealslate shrink-0 mt-1" data-id="element-534" />
            <div data-id="element-535">
              <h3 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-536">
                Start Simple
              </h3>
              <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-537">
                Any movement is better than none. Once you start, it gets easier
                to build from there.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4" data-id="element-538">
            <div className="w-6 h-6 rounded-full bg-tealslate text-white flex items-center justify-center font-bold shrink-0 mt-1 text-sm" data-id="element-539">
              !
            </div>
            <div data-id="element-540">
              <h3 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-541">
                The 10-Minute Rule
              </h3>
              <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-542">
                Start with walking if you're new to exercise. Even 10-minute
                walks after meals can make a significant difference for blood
                sugar control.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}